import React from 'react';
import '../assets/css/style.css';

function FilterButton(props) {
    return (
        <>
            <button className="filterbtn" {...props} style={props.style}>
                {props.btnname}
            </button>
        </>
    );
}

export default FilterButton;
